// extracted by mini-css-extract-plugin
export default {"paginationBlock":"pagination_paginationBlock__kQFrw","but":"pagination_but__k7mH1","active":"pagination_active__oKGB-"};